import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";

import { Language } from "../../models/language.model";

@Injectable()
export class LanguageProvider extends Api {

  langs: Array<Language> = new Array();
  defaultLangs: Array<Language>;

  constructor(public http: HttpClient) {
    super(http);
    this.defaultLangs = [
      new Language({
        code: "en_GB",
        name: "English",
        locale: "en",
        flag: "gb"
      }),
      new Language({
        code: "fr_FR",
        name: "Français",
        locale: "fr",
        flag: "fr"
      }),
      new Language({
        code: "es_ES",
        name: "Español",
        locale: "es",
        flag: "es"
      }),
      new Language({
        code: "ar_AE",
        name: "العربية",
        locale: "ar",
        flag: "ae"
      })
    ];
  }

  setLangs(langs: Array<Language>) {
    langs.map(newLang => {
      const langFound = this.langs.filter(lang => lang.code == newLang.code);
      if (!langFound) {
        this.langs.push(newLang);
      }
    });
  }

  getLangs(): Observable<Language[]> {
    return this.http
      .get<Language[]>(`${this.url}/languages`)
      .map(response => {
        this.langs = response.map((lang) => {
          let langInstance = new Language(lang);
          return langInstance;
        });

        return this.langs;
      })
      .catch(this.handleError);
  }

  getByLocale(locale: string): Language {
    let res;
    if(this.langs) {
      res = this.langs.find(l => l.locale == locale);
    } else {
      res = this.defaultLangs.find(l => l.locale == locale);
    }

    if (!res) {
      res = this.defaultLangs[0];
    }

    return res;
  }
}



// WEBPACK FOOTER //
// ./src/providers/language/language.ts